(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog"]) return;
  try {
    
  document.addEventListener("DOMContentLoaded", () => {
  const tabs = document.querySelectorAll(".tab-button");
  const cards = document.querySelectorAll(".blog-card");
  const noMessage = document.getElementById("no-blogs-message");

  tabs.forEach(tab => {
    tab.addEventListener("click", () => {
      const category = tab.getAttribute("data-tab");

      // update active tab style
      tabs.forEach(t => t.classList.remove("text-primary","border-b-2","border-primary"));
      tab.classList.add("text-primary","border-b-2","border-primary");

      // filter cards
      let visibleCount = 0;
      cards.forEach(card => {
        if (category === "all" || card.dataset.category.includes(category)) {
          card.classList.remove("hidden");
          visibleCount++;
        } else {
          card.classList.add("hidden");
        }
      });

      // toggle "No blogs" message
      if (visibleCount === 0) {
        noMessage.classList.remove("hidden");
      } else {
        noMessage.classList.add("hidden");
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  function toggleDropdown() {
    const dropdown = document.getElementById("dropdown");
    if (dropdown) {
      dropdown.classList.toggle("hidden");
    }
  }

  function toggleFaq(element) {
    const answer = element.querySelector(".faq-answer");
    const plusIcon = element.querySelector(".toggle-icon.plus");
    const minusIcon = element.querySelector(".toggle-icon.minus");

    if (!answer) return;

    // Collapse all other answers
    document.querySelectorAll(".faq-answer").forEach((el) => {
      if (el !== answer) {
        el.style.maxHeight = null;
        const parent = el.closest(".faq-item");
        if (parent) {
          const pPlus = parent.querySelector(".toggle-icon.plus");
          const pMinus = parent.querySelector(".toggle-icon.minus");
          if (pPlus) pPlus.classList.remove("hidden");
          if (pMinus) pMinus.classList.add("hidden");
        }
      }
    });

    // Toggle this one
    if (answer.style.maxHeight) {
      answer.style.maxHeight = null;
      if (plusIcon) plusIcon.classList.remove("hidden");
      if (minusIcon) minusIcon.classList.add("hidden");
    } else {
      answer.style.maxHeight = answer.scrollHeight + "px";
      if (plusIcon) plusIcon.classList.add("hidden");
      if (minusIcon) minusIcon.classList.remove("hidden");
    }
  }

  // Expose globally so onclick works in Liquid/HTML
  window.toggleDropdown = toggleDropdown;
  window.toggleFaq = toggleFaq;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
 function handleScroll() {
    const header = document.querySelector(".site-header");
    if (!header) return;

    // "Always solid" is on — leave the header alone
    if (header.classList.contains("is-locked")) return;

    const isMobile = window.innerWidth <= 768;
    const scrollTrigger = isMobile ? 10 : 40;

    header.classList.toggle("is-scrolled", window.scrollY > scrollTrigger);
  }

  // Run once on load
  window.addEventListener("DOMContentLoaded", handleScroll);

  // Run on scroll
  window.addEventListener("scroll", handleScroll);


  const navOpenBtn = document.querySelector(".nav-open-btn");
    const navCloseBtn = document.querySelector(".nav-close-btn");
  const sidebar = document.querySelector(".mobile-header");
  const overlay = document.querySelector(".mobile-overlay");
  const body = document.body;

  navOpenBtn.addEventListener("click", () => {
    overlay.classList.remove("invisible"); // show overlay
    sidebar.classList.remove("translate-x-full"); // slide in
    body.classList.add("overflow-hidden");
  });

  navCloseBtn.addEventListener("click", () => {
    sidebar.classList.add("translate-x-full"); // slide out
    body.classList.remove("overflow-hidden");

    // wait for slide animation to finish before hiding overlay
    setTimeout(() => {
      overlay.classList.add("invisible");
    }, 350); // match CSS transition duration
  });


  /* ---- Expanding header search ---- */
  (function () {
    const searchForm  = document.getElementById("header-search");
    const searchInput = document.getElementById("header-search-input");
    const openBtn     = document.getElementById("open-search");
    const closeBtn    = document.getElementById("close-search");

    if (!searchForm || !searchInput || !openBtn || !closeBtn) return;

    function openSearch() {
      searchForm.classList.add("is-open");
      openBtn.setAttribute("aria-expanded", "true");
      // wait for the panel to start expanding before focusing
      setTimeout(() => searchInput.focus(), 120);
    }

    function closeSearch() {
      searchForm.classList.remove("is-open");
      openBtn.setAttribute("aria-expanded", "false");
      searchInput.blur();
    }

    openBtn.addEventListener("click", openSearch);
    closeBtn.addEventListener("click", closeSearch);

    // Esc closes
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && searchForm.classList.contains("is-open")) closeSearch();
    });

    // Click outside closes
    document.addEventListener("click", (e) => {
      if (!searchForm.classList.contains("is-open")) return;
      if (searchForm.contains(e.target) || openBtn.contains(e.target)) return;
      closeSearch();
    });

    // Don't submit an empty query
    searchForm.addEventListener("submit", (e) => {
      if (!searchInput.value.trim()) {
        e.preventDefault();
        searchInput.focus();
      }
    });
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-section"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const heroEl = document.querySelector(".hero-swiper");
    if (!heroEl || typeof Swiper === "undefined") return;

    const section = heroEl.closest(".herosetiontop");
    const delay =
      parseInt(section && section.dataset.autoplayDelay, 10) || 2000;

    const heroSwiper = new Swiper(".hero-swiper", {
      loop: true,
      autoplay: {
        delay: delay,
        disableOnInteraction: false,
      },
      speed: 1000,
      effect: "slide",

      on: {
        init: function () {
          const lines = document.querySelectorAll(".control .progress-line");
          this._firstBarAnimated = false;

          lines.forEach((line, i) => {
            line.classList.remove(
              "transition-all",
              "duration-400",
              "ease-linear",
              "w-full",
              "w-1/2"
            );

            if (i === 0) {
              void line.offsetWidth;
              line.classList.add("transition-all", "duration-400", "ease-linear");

              setTimeout(() => {
                line.classList.add("w-full");
                this._firstBarAnimated = true;
              }, 10);
            }
          });
        },

        slideChange: (function () {
          let animTimeout;

          function updateProgressBar(targetIndex) {
            const lines = document.querySelectorAll(".control .progress-line");
            const total = lines.length;
            const current =
              typeof targetIndex === "number" ? targetIndex : this.realIndex;

            if (animTimeout) {
              clearTimeout(animTimeout);
              animTimeout = null;
            }

            if (current === 0) {
              lines.forEach((line, i) => {
                line.classList.remove(
                  "transition-all",
                  "duration-400",
                  "ease-linear",
                  "w-full",
                  "w-1/2"
                );

                if (i === 0) {
                  if (!this._firstBarAnimated) {
                    void line.offsetWidth;
                    line.classList.add(
                      "transition-all",
                      "duration-400",
                      "ease-linear"
                    );

                    setTimeout(() => {
                      line.classList.add("w-full");
                      this._firstBarAnimated = true;
                    }, 150);
                  } else {
                    line.classList.add("w-full");
                  }
                }
              });

              return;
            } else {
              this._firstBarAnimated = false;
            }

            lines.forEach(line =>
              line.classList.add("transition-all", "duration-400", "ease-linear")
            );

            lines.forEach(line => line.classList.remove("w-full", "w-1/2"));

            for (let i = 0; i < current - 1; i++) {
              lines[i].classList.add("w-full");
            }

            if (current - 1 >= 0) {
              lines[current - 1].classList.add("w-full");
            }

            animTimeout = setTimeout(() => {
              if (current < total) {
                lines[current].classList.add(
                  current === total - 1 ? "w-full" : "w-1/2"
                );
              }
            }, 400);
          }

          function updateProgressBarEarly(targetIndex) {
            updateProgressBar.call(this, targetIndex);
          }

          return function () {
            this.updateProgressBar = updateProgressBar.bind(this);
            this.updateProgressBarEarly = updateProgressBarEarly.bind(this);
            updateProgressBar.call(this);
          };
        })(),
      },
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instruments-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const tabContainer = document.getElementById('tabContainer');
    const scrollLeft = document.getElementById('scrollLeft');
    const scrollRight = document.getElementById('scrollRight');

    function toggleScrollButtons() {
      // Hide on mobile (<= 768px)
      if (window.innerWidth < 768) {
        scrollLeft.style.display = 'none';
        scrollRight.style.display = 'none';
        return;
      }

      // Hide both if not scrollable
      if (tabContainer.scrollWidth <= tabContainer.clientWidth) {
        scrollLeft.style.display = 'none';
        scrollRight.style.display = 'none';
        return;
      }

      // Left button logic
      scrollLeft.style.display = tabContainer.scrollLeft <= 5 ? 'none' : 'flex';

      // Right button logic
      scrollRight.style.display =
        tabContainer.scrollLeft + tabContainer.clientWidth >= tabContainer.scrollWidth - 5 ? 'none' : 'flex';
    }

    // Scroll actions
    scrollLeft.addEventListener('click', () => {
      tabContainer.scrollBy({ left: -200, behavior: 'smooth' });
    });
    scrollRight.addEventListener('click', () => {
      tabContainer.scrollBy({ left: 200, behavior: 'smooth' });
    });

    // Events
    tabContainer.addEventListener('scroll', toggleScrollButtons);
    window.addEventListener('resize', toggleScrollButtons);

    // Initial
    toggleScrollButtons();
  });

  document.addEventListener('DOMContentLoaded', function () {
    const tabButtons = document.querySelectorAll('.tab-button');
    const tabContents = document.querySelectorAll('.tab-content');

    tabButtons.forEach((button) => {
      button.addEventListener('click', function () {
        const targetTab = this.getAttribute('data-tab');

        // Remove active classes from all buttons
        tabButtons.forEach((btn) => {
          btn.classList.remove('text-primary', 'border-b-2', 'border-primary');
          btn.classList.add('text-foreground');
        });

        // Add active classes to clicked button
        this.classList.remove('text-foreground');
        this.classList.add('text-primary', 'border-b-2', 'border-primary');

        // Hide all tab contents
        tabContents.forEach((content) => {
          content.classList.add('hidden');
        });

        // Show target tab content
        document.getElementById(targetTab).classList.remove('hidden');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-features"] && !Shopify.designMode) return;
  try {
    
  const headers = document.querySelectorAll('.accordion-header');
  const images = document.querySelectorAll('.accordion-image');

  headers.forEach((header) => {
    header.addEventListener('click', () => {
      const item = header.closest('.accordion-item');
      const imgIndex = item.getAttribute('data-image');
      const content = header.querySelector('.accordion-content');

      document.querySelectorAll('.accordion-item').forEach((el) => {
        const iconBox = el.querySelector('div.size-10, div.size-12, div.md\\:size-12');
        if (iconBox) {
          iconBox.classList.remove('border-icon-border', 'bg-icon-bg');
          iconBox.classList.add('border-card-border', 'bg-card-bg');
        }
        const icon = el.querySelector('svg, i');
        if (icon) {
          icon.classList.remove('text-primary');
          icon.classList.add('text-text-muted');
        }
        const heading = el.querySelector('h5');
        if (heading) {
          heading.classList.remove('text-primary');
          heading.classList.add('text-foreground');
        }
        el.querySelector('.accordion-content')?.classList.add('hidden');
      });

      images.forEach((img) => img.classList.add('hidden'));

      const iconBox = item.querySelector('div.size-10, div.size-12, div.md\\:size-12');
      if (iconBox) {
        iconBox.classList.remove('border-card-border', 'bg-card-bg', 'font-medium');
        iconBox.classList.add('border-icon-border', 'bg-icon-bg', 'font-medium');
      }

      const icon = item.querySelector('svg, i');
      if (icon) {
        icon.classList.remove('text-text-muted');
        icon.classList.add('text-primary');
      }

      const heading = item.querySelector('h5');
      if (heading) {
        heading.classList.remove('text-foreground');
        heading.classList.add('text-primary');
      }

      content.classList.remove('hidden');
      images[imgIndex].classList.remove('hidden');
    });
  });

  if (headers.length > 0) {
    headers[0].click();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-services"] && !Shopify.designMode) return;
  try {
    
  var swiper = new Swiper(".ourServicesSwiper", {
      slidesPerView: "auto",
      spaceBetween: 8,
      grabCursor: true,
      breakpoints: {
        320: { spaceBetween: 8 },
        768: { spaceBetween: 16 },
        1024: { spaceBetween: 24 }
      }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-trusted-clients"] && !Shopify.designMode) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {

  // Agar marquee mode hai to Swiper initialize mat karo
  if (document.querySelector(".logo-marquee")) return;

  const swiperWrapper = document.querySelector(".logo-swiper .swiper-wrapper");
  if (!swiperWrapper) return;

  const originalSlides = Array.from(swiperWrapper.querySelectorAll(".swiper-slide"));

  // Prevent duplicate clones
  if (!swiperWrapper.dataset.cloned) {
    for (let i = 0; i < 10; i++) {
      originalSlides.forEach(slide => {
        swiperWrapper.appendChild(slide.cloneNode(true));
      });
    }
    swiperWrapper.dataset.cloned = "true";
  }

  if (!swiperWrapper.swiper) {
    new Swiper(".logo-swiper", {
      slidesPerView: "auto",
      spaceBetween: 64,
      loop: true,
      loopedSlides: 9,
      speed: 4000,
      allowTouchMove: false,
      freeMode: true,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
      breakpoints: {
        320: { spaceBetween: 20, loopedSlides: 6 },
        640: { spaceBetween: 32, loopedSlides: 7 },
        1024: { spaceBetween: 64, loopedSlides: 9 },
      },
    });
  }

});


  } catch(e) { console.error(e); }
})();
})();
